import { defineStore } from 'pinia'

export const useGoogleMapsStore = defineStore('googleMaps', {
  state: () => ({
    isLoaded: false
  }),
  actions: {
    setLoaded (isLoaded) {
      this.isLoaded = isLoaded
    }
  }
})
